import React, { Component } from 'react';
import { Container } from 'flux/utils';
import AssetStore from '../../stores/AssetStore';
import { withId } from '../Common/Decorators';
import DetailView from '../Common/DetailView';
import AssetForm, { validate } from './AssetForm';
import { discardAssetDraft, editAsset, saveAndDiscardAsset } from '../../actions/AssetActionCreator';
import { Card, CardActions, CardText, CardTitle } from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import { browserHistory } from 'react-router';

class AssetEditPage extends Component {

    componentDidMount() {
        editAsset(this.props.id, true);
    }

    componentWillUnmount() {
        discardAssetDraft();
    }

    render() {
        const { draft } = this.state;
        if (!draft && this.state.isFetching) { return <DetailView />; } // isFetching?
        const errors = !!draft && validate(draft);

        return (
            <DetailView>
                <div className="cent-cards">
                {!!draft && (
                    <Card className="cent-card">
                        <CardTitle title="Edit asset" />
                        <CardText>
                            <AssetForm
                                draft={draft}
                                errors={errors}
                                allowWysiwyg={draft.type.name === 'text'}
                            />
                        </CardText>
                        <div className="cent-card-actions">
                            <CardActions>
                                <RaisedButton
                                    label="Cancel"
                                    onTouchTap={() => browserHistory.goBack()}
                                />
                                <RaisedButton
                                    label="Save"
                                    primary={true}
                                    disabled={this.state.isFetching || (Object.values(errors).length > 0)}
                                    onTouchTap={() => saveAndDiscardAsset().then(() => browserHistory.goBack())}
                                />
                            </CardActions>
                        </div>
                    </Card>
                )}
                </div>
            </DetailView>
        );
    }


}

AssetEditPage.getStores = () => ([AssetStore]);
AssetEditPage.calculateState = (prevState) => ({
    ...prevState,
    isFetching: AssetStore.isFetching(),
    draft: AssetStore.getDraft(),
});

export default withId(Container.create(AssetEditPage));
